import { MockChipRow, MockProgress, MockStatGrid } from '@nexa/ui';
import { useCopy } from '@/core/i18n';

/** View 0 — `template.html:854`. Sprint đang chạy: tiến độ, 4 stat, 3 chip. */
export function SprintView() {
  const sprint = useCopy().pm.sprint;

  return (
    <div>
      <div className="flex flex-wrap items-center gap-3">
        <span className="text-title font-bold text-ink-900">{sprint.title}</span>
        <span className="rounded-pill bg-success-bg px-2.5 py-[3px] text-micro font-bold text-success-fg">
          {sprint.status}
        </span>
        <span className="ml-auto text-caption text-ink-600">{sprint.range}</span>
      </div>

      <div className="mt-4">
        <MockProgress percent={sprint.percent} label={sprint.progressLabel} />
      </div>

      <div className="mt-2 text-caption text-ink-600">
        <b className="text-ink-900">{sprint.progressStrong}</b> {sprint.progressLabel}
      </div>

      <div className="mt-6">
        <MockStatGrid stats={sprint.stats} />
      </div>

      <div className="mt-5">
        <MockChipRow chips={sprint.chips} />
      </div>
    </div>
  );
}
